<template>
  <pre class="pre-article"></pre>
</template>

<script>
export default {
  name: "Article"
};
</script>

<style lang="scss" scoped>
.pre-article {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: justify;

  /deep/ p {
    font-size: 15px;
    letter-spacing: 2px;
    font-family: "Times New Roman", "宋体";
  }

  /deep/ small {
    color: #999aaa;
  }

  /deep/ .p50 {
    display: inline-block;
    width: 50%;
    margin: 0 auto;
  }

  /deep/ .p80 {
    display: block;
    width: 80%;
    margin: 0 auto;
  }

  /deep/ .center {
    display: block;
    font-size: 13px;
    text-align: center;
    margin: 0 auto;
  }

  /deep/ table {
    width: 100%;
    border-top: 1px solid #000000;
    border-left: 1px solid #000000;
    border-collapse: collapse;
  }

  /deep/ td {
    padding: 14px;
    border-bottom: 1px solid #000000;
    border-right: 1px solid #000000;
  }
}
</style>
